export default __webpack_public_path__ + "i18n/translations/translation-hi.f7711a56.json";